import * as types from "./mutation-types";

export default {
  [types.SET_SERVICESLIST](state, payload) {
    state.servicesList = payload;
  },
};
